import React from 'react';
import { Bundle } from '@ali/visualengine';
import {
  generateIndex,
  getDataSourceList,
  getDsNameFromVariable,
  removeDataSourceByNode,
} from '@/common/util/util';
import { getItemInitialValue } from '@/common/manager/filter-item';
import { DisplayPosition } from '@/type/display-position';
import {
  createFormDefaultValueSetters,
  createFormItemSetters,
} from '@/lowcode/cn-form/form-item';
import { ButtonPosition } from '@/type/button-position';
import { createEventSetters } from '@/common/manager/event';
import DataSourceSetter from '@/common/setter/datasource-setter/datasource-setter';
import IdSetter from '@/common/setter/id-setter';

const { VisualEngine } = window;
const Engine = VisualEngine;
const { ActionSetter } = window.VisualEngineUtils || {};

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  title: '筛选栏',
  componentName: 'CnFilter',
  category: 'FTP',
  onNodeRemoveByUser(node) {
    removeDataSourceByNode(node);
  },
  isContainer: false,
  configure: [
    {
      name: 'isCnFilter',
      title: 'isCnFilter',
      initialValue: true,
      display: 'none',
    },
    {
      name: 'title',
      title: '筛选栏名称',
      display: 'inline',
      initialValue: '筛选栏1',
      tip: '当前筛选栏的名称，方便检索使用',
      setter: 'StringSetter',
    },
    {
      name: 'config',
      title: '筛选项配置',
      display: 'accordion',
      initialValue: [
        getItemInitialValue({
          position: DisplayPosition.filter,
        }),
      ],
      setter: createFormItemSetters({ position: DisplayPosition.filter }),
    },
    {
      name: '_bindTable',
      title: '关联表格',
      mutator(value) {
        if (value) {
          const tableNode = this.getNode?.()?.document?.getNode?.(value);
          if (tableNode) {
            const _dataSourceName =
              this?.parent?.getPropValue?.('_dataSourceName');
            if (_dataSourceName) {
              tableNode.setPropValue(
                '_bindFilterDataSourceName',
                _dataSourceName,
              );
            }
          }
        }
      },
      setter(prop) {
        const options = [];
        prop?.getNode?.()?.document?.nodesMap?.forEach((item) => {
          if (item.getPropValue('isCnTable')) {
            const id = item.id || '';
            const tableName = item?.propsData?.tableName || '';
            // let title = id;
            // if (title.slice(0, 4) === 'node') {
            //   title = title.replace('node', '表格');
            // }
            const title = `表格_${tableName}`;
            options.push({
              title,
              value: id,
            });
          }
        });
        return {
          componentName: 'CnSelectSetter',
          props: {
            options,
            selectProps: {
              hasClear: true,
            },
          },
        };
      },
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      name: 'filterStyle',
      display: 'accordion',
      title: '筛选栏样式',
      collapsed: true,
      extraProps: {
        defaultCollapsed: true,
      },
      setter: {
        componentName: 'ObjectSetter',
        props: {
          config: {
            items: [
              {
                title: '隐藏筛选按钮',
                name: 'hiddenFilterButton',
                defaultValue: false,
                setter: 'BoolSetter',
              },
              // {
              //   title: '展开/收起',
              //   name: 'showFolder',
              //   defaultValue:true,
              //   setter: 'BoolSetter'
              // },
              // {
              //   title: '以tag形式展示选中项',
              //   name: 'showSelected',
              //   defaultValue:false,
              //   setter: 'BoolSetter'
              // },
              // {
              //   title: '筛选栏排序',
              //   name: 'enableConfig',
              //   defaultValue:false,
              //   setter: 'BoolSetter'
              // },
              // {
              //   title: '我的查询条件',
              //   name: 'enableSaveSelected',
              //   defaultValue:false,
              //   setter: 'BoolSetter'
              // },
              // {
              //   title: '点击重置后是否需要自动查询',
              //   name: 'afterResetNeedQuery',
              //   defaultValue:true,
              //   setter: 'BoolSetter'
              // },
              // {
              //   title: '默认可见行数',
              //   name: 'maxVisibleRow',
              //   setter: 'NumberSetter'
              // },
              // {
              //   title: '开启查询条件暂存',
              //   name: 'cacheSearch',
              //   setter: 'BoolSetter'
              // },
            ],
          },
        },
      },
    },
    ...createFormDefaultValueSetters({
      position: DisplayPosition.filter,
      afterRequestSuccessPosition:
        ButtonPosition.filterDefaultValueAfterRequestSuccess,
    }),
    ...createEventSetters({
      position: ButtonPosition.filterEvent,
      initialValue: {
        optType: 'flowAction',
      },
      title: '配置筛选栏的回调',
    }),
    {
      title: '高级配置',
      type: 'group',
      collapsed: true,
      display: 'accordion',
      items: [
        // {
        //   name: 'isCnFilterPro',
        //   title: '使用高级筛选栏',
        //   display: 'inline',
        //   initialValue: true,
        //   setter: 'BoolSetter',
        // },
        {
          name: '_nodeId',
          title: '节点 ID',
          display: 'inline',
          initialValue() {
            return this.getNode().id;
          },
          setter: <IdSetter />,
        },
        {
          name: '_dataSource',
          title: '数据源',
          display: 'inline',
          supportVariable: false,
          mutator(value) {
            const node = this.getProps().getNode();
            const result = getDsNameFromVariable(value);
            if (result) {
              node.setPropValue('_dataSourceName', result);
            }
          },
          initialValue(value) {
            const v = this.getValue();
            // if (value) {
            //   return value;
            // }
            // if(Engine?.Exchange?.hoveringNode){
            //   const node = this.getNode();
            //   const {componentName} = node;
            //   const currentDataSource = node.getPropValue('_dataSource');
            const { componentName } = this;
            const currentDataSource = this.getPropValue('_dataSource');
            if (!currentDataSource && !v) {
              let dataSourceList = [];
              dataSourceList = getDataSourceList();
              let index = '';
              const first = dataSourceList?.find(
                (item) => item.value === `${componentName}`,
              );
              if (first) {
                index = generateIndex(dataSourceList, componentName);
              }
              if (Engine) {
                const componentPrototype =
                  Engine?.designer?.getComponentMeta?.(
                    componentName,
                  )?.prototype;
                const dataSource = Engine?.context?.getManager('dataPool');
                const ds = dataSource?.addItem({
                  description: `${
                    componentPrototype?.options?.title || componentName
                  }${index}的数据源`,
                  dpType: 'VALUE',
                  id: '',
                  initialData: '',
                  isGlobal: false,
                  name: `${componentName}${index}`,
                  protocal: 'VALUE',
                });
                if (ds?.name) {
                  // this.setPropValue('_dataSourceName',ds.name)
                  this.parent?.setPropValue?.('_dataSourceName', ds.name);
                  return {
                    type: 'variable',
                    variable: `state.${ds.name}`,
                  };
                }
              }
            }
          },
          setter: <DataSourceSetter />,
        },
        {
          name: '_dataSourceName',
          title: '数据源名称',
          display: 'none',
          // supportVariable: true,
          initialValue() {
            const value = this.parent?.getPropValue?.('_dataSourceName');
            if (!value) {
              const node = this.getNode();
              const dsExpr = node?.getPropValue('_dataSource');
              return getDsNameFromVariable(dsExpr);
            }
            return value;
          },
        },
        //         {
        //           name: 'onGetStorage',
        //           title: '获取习惯(onGetStorage)',
        //           display: 'inline',
        //           setter: <ActionSetter
        //             supportTypes={['page']}
        //             defaultCode={`/**
        // * onGetStorage
        // *
        // * @param key string
        // * @param type string
        // */
        // function onGetStorage(key, type) {
        //
        // }`}
        //             defaultActionName="onGetStorage"
        //           />
        //         },
        //         {
        //           name: 'onSetStorage',
        //           title: '设置习惯(onSetStorage)',
        //           display: 'inline',
        //           setter: <ActionSetter
        //             supportTypes={['page']}
        //             defaultCode={`/**
        // * onSetStorage
        // *
        // * @param key string
        // * @param type string
        // * @param values string
        // */
        // function onSetStorage(key, type, values) {
        //
        // }`}
        //             defaultActionName="onSetStorage"
        //           />
        //         },
      ],
    },
  ],
});
